import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"
import SectionTitle from "../components/common/SectionTitle"
import CTASection from "../components/home/CTASection"

export default function About() {
  return (
    <>
      <SEO
        title="À Propos"
        description="Découvrez notre entreprise spécialisée dans la vente en gros de fournitures textiles, mercerie et accessoires pour professionnels."
        keywords="grossiste textile, mercerie, fournitures textiles, entreprise textile Tunisie"
        url="https://www.khenissitextiles.com/a-propos"
      />

      <PageBanner
        title="À Propos"
        subtitle="Votre partenaire de confiance pour les fournitures textiles et la mercerie professionnelle."
      />

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">

          <SectionTitle
            badge="Notre Entreprise"
            title="Une expertise au service des professionnels"
            description="Nous accompagnons les ateliers, confectionneurs, tapissiers, couturiers et commerçants avec une large sélection de fournitures textiles de qualité."
          />

          <div className="grid lg:grid-cols-2 gap-12 items-center mt-16">
{/*
            <div>
              <img
                src="/images/about.jpg"
                alt="Entreprise textile"
                loading="lazy"
                className="w-full h-full object-cover rounded-3xl shadow-lg"
              />
            </div>
*/}
            <div className="space-y-6">

              <h2 className="text-3xl font-bold text-gray-900">
                Un large choix de produits textiles
              </h2>

              <p className="text-gray-600 leading-relaxed">
                Notre entreprise propose une vaste gamme de produits
                destinés aux professionnels du textile et de la
                confection : fermetures, fils, tissus, élastiques,
                velcro, boutons et accessoires.
              </p>

              <p className="text-gray-600 leading-relaxed">
                Nous sélectionnons soigneusement nos références afin
                d'offrir un excellent rapport qualité-prix et une
                disponibilité adaptée aux besoins du marché.
              </p>

              <p className="text-gray-600 leading-relaxed">
                Notre objectif est d'établir une relation durable avec
                nos clients grâce à un service fiable, réactif et
                professionnel.
              </p>

            </div>

          </div>

        </div>
      </section>

      <CTASection />
    </>
  )
}